Comment = function(data) {
    var self = this;

    var props = [
        {name: 'username'},
        {name: 'name'},
        {name: 'avatar'},
        {name: 'content', save: true},
        {name: 'excerpt'},
        {name: 'created_at', save: true},
        {name: 'updated_at', save: true},
        {name: 'likesCount', save: true},
        {name: 'likes', data_type: 'object'},
        {name: 'attachments', data_type: 'array', save: true},
        {name: 'liked_by_me', save: true, data_type: 'boolean'},
        {name: 'accepted_answer', save: true, data_type: 'boolean'},
        {name: 'highlighted', data_type: 'boolean', default: false},
        {name: 'karma'},
        {name: 'level'},
        {name: 'isAdmin', data_type: 'boolean', default: false},
        {name: 'isModerator', data_type: 'boolean', default: false},
        {name: 'permissions', data_type: 'array'},
        {name: 'streak', data_type: 'integer', default: null},
        {name: 'active_trophy', data_type: 'object', default: null},
    ];

    self.activeDataRelations = [
        {type: 'hasMany', storeTarget: 'replies', key: 'comment_id', storage: 'replies'},
        {type: 'hasMany', storeTarget: 'likes', key: 'comment_id', storage: 'likes'},
        {type: 'belongsTo', storeTarget: 'topics', key: 'conversation_id', storage: 'topic'},
        {type: 'belongsTo', storeTarget: 'users', key: 'user_id', storage: 'user'}
    ];

    //permissions hotfix
    self.activeDataCustomSetup = function(data) {
        /*
        var object_props = [
            {name: 'accept_answer', default: false},
            {name: 'delete_comment', default: false},
            {name: 'edit_comment', default: false},
            {name: 'like_comment', default: false},
        ];

        _.each(object_props, function(prop) {
            if(typeof(data.permissions[prop.name]) === 'undefined') {
                self.permissions[prop.name] = prop.default; //set default
            }
        });
        */
    };
    
    ActiveData.call( self, data); //javascript 'classes' workaround
    self.activeDataInit(self, data, props); //setup active data
};